import * as React from 'react';
import { IgcGridToolbarPinningComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import type { IgcGridToolbarPinningComponentEventMap } from 'igniteui-webcomponents-grids/grids/index.js';
import { type EventName, createComponent } from '../react-props.js';

/**
 * Provides a pre-configured column pinning component for the grid.
 * @fires opening - Emits an event before the toggle container is opened.
 * @fires opened - Emits an event after the toggle container is opened.
 * @fires closing - Emits an event before the toggle container is closed.
 * @fires closed - Emits an event after the toggle container is closed.
 * @fires columnToggle - Emits when after a column's checked state is changed
 */
export const IgrGridToolbarPinning = createComponent({
  tagName: 'igc-grid-toolbar-pinning',
  displayName: 'IgrGridToolbarPinning',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
  events: {
    onOpening: 'opening' as EventName<
      IgcGridToolbarPinningComponentEventMap['opening']
    >,
    onOpened: 'opened' as EventName<
      IgcGridToolbarPinningComponentEventMap['opened']
    >,
    onClosing: 'closing' as EventName<
      IgcGridToolbarPinningComponentEventMap['closing']
    >,
    onClosed: 'closed' as EventName<
      IgcGridToolbarPinningComponentEventMap['closed']
    >,
    onColumnToggle: 'columnToggle' as EventName<
      IgcGridToolbarPinningComponentEventMap['columnToggle']
    >,
  },
});

export type IgrGridToolbarPinning = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrGridToolbarPinningModule = Component;
